{
  "toast": {
    "experimentCreated": "Experiment créé",
    "winnerDeclared": "Winner declared",
    "marketingCampaignRegistered": "Marketing campaign registered",
    "enrichmentAppliedFromEmailDomain": "Enrichment applied de email domain",
    "formCreatedAndPublishedSuccessfully": "Form créé et published successfully!",
    "formArchived": "Form archived",
    "landingPageCreatedPublished": "Landing page créé & published",
    "routingRuleSaved": "Routing rule enregistré",
    "leadScoringRuleSaved": "Lead scoring rule enregistré",
    "sourceCreated": "Source créé"
  },
  "errors": {
    "nameAndSlugRequired": "Name et slug requis",
    "failedToLoadExperiments": "Échec du chargement de experiments",
    "failedToLoadLandingPages": "Échec du chargement de landing pages",
    "createFailed": "Échec de la création",
    "failedToDeclareWinner": "Échec : declare winner",
    "failedToLoadCampaigns": "Échec du chargement de campaigns",
    "failedToCreateCampaign": "Échec de la création de campaign",
    "failedToLoadConsentLogs": "Échec du chargement de consent logs",
    "crmLeadIdAndEmailRequired": "CRM lead ID et email requis",
    "noEnrichmentForThisLeadYet": "No enrichment pour ce lead yet",
    "enrichmentFailed": "Échec de enrichment",
    "failedToLoadForms": "Échec du chargement de forms",
    "failedToCreateForm": "Échec de la création de form",
    "failedToUpdateForm": "Échec de la mise à jour de form",
    "failedToDeleteForm": "Échec : delete form",
    "failedToCreateLandingPage": "Échec de la création de landing page",
    "formNotFound": "Form pas found",
    "submissionFailed": "Échec de la soumission",
    "validationFailed": "Échec de la validation",
    "missingRequiredField": "Champ obligatoire manquant : {{field}}",
    "failedToLoadReports": "Échec du chargement de reports",
    "failedToLoadRoutingRequirements": "Échec du chargement de routing requirements",
    "failedToCreateRoutingRule": "Échec de la création de routing rule",
    "failedToLoadScoringRules": "Échec du chargement de scoring rules",
    "failedToCreateScoringRule": "Échec de la création de scoring rule",
    "failedToLoadSources": "Échec du chargement de sources",
    "failedToCreateSource": "Échec de la création de source",
    "failedToLoadVisitorProfiles": "Échec du chargement de visitor profiles"
  },
  "pages": {
    "aBLandingTests": "A/B landing tests",
    "trafficSplitExperimentsAcrossLandingPage": "Traffic-split experiments across landing page variants",
    "marketingCampaignsRoi": "Marketing Campaigns & ROI",
    "linkAdvertisingCostsUtmParametersAnd": "Link advertising costs, UTM parameters, et multi-touch revenue attribution modeling.",
    "gdprConsentTracking": "GDPR & Consent Tracking",
    "configurePrivacyBannersTrackPolicyConsent": "Configure privacy banners, track policy consent versions, et audit utiliserr acceptance logs.",
    "leadGenDashboard": "Lead Gen Tableau de bord",
    "additionalMetrics": "Additional metrics",
    "totalVisitors": "Total visitors",
    "conversions": "Conversions",
    "avgLeadScore": "Avg. lead score",
    "inboundAcquisitionFunnel": "Inbound acquisition funnel",
    "leadScoreDistribution": "Lead score distribution",
    "campaignRoi": "Campaign ROI",
    "visitorTrackingFormsScoringAndCrm": "Visitor tracking, forms, scoring, et CRM conversion in votre scope",
    "leadEnrichment": "Lead enrichment",
    "domainInferenceAndFirmographicHintsRuns": "Domain inference et firmographic hints — runs automatically on form submit; manual refresh here",
    "acquisitionLeadForms": "Acquisition Lead Forms",
    "visualFormBuilderAndSecureEmbedding": "Visual Form Builder et secure embedding configurations.",
    "landingPageBuilder": "Landing Page Builder",
    "launchHighConvertingLandingPagesWith": "Launch high-converting landing pages avec native A/B testing et custom domain support.",
    "leadGenReports": "Lead Gen Rapports",
    "leadSourceReport": "Lead Source Rapport",
    "campaignReport": "Campaign Rapport",
    "conversionReport": "Conversion Rapport",
    "scoringReport": "Scoring Rapport",
    "attributionReport": "Attribution Rapport",
    "roiReport": "ROI Rapport",
    "leadSourceCampaignConversionScoringAttribution": "Lead source, campaign, conversion, scoring, attribution, et ROI analytics.",
    "leadRoutingTerritories": "Lead Routing & Territories",
    "configureAutomatedAssignmentCriteriaByCountry": "Configure automated assignment criteria by country, region, state, ou produit, avec integrated round-robin distribution.",
    "leadScoringGrading": "Lead Scoring & Grading",
    "establishScoringThresholdsAndAssignQuality": "Establish scoring thresholds et assign quality grades (A+, A, B, C, D) based on visitor events et profiles.",
    "leadSources": "Lead Sources",
    "acquisitionChannelCatalogWebsiteAdsSocial": "Acquisition channel catalog — website, ads, social, partner portal, et API imports.",
    "visitorSessionTracking": "Visitor Session Tracking",
    "monitorAnonymousVisitorPathsReferrersAnd": "Monitor anonymous visitor paths, referrers, et cookie IDs prior à lead conversion.",
    "leadAdWebhooks": "Lead ad webhooks",
    "facebookAndGoogleLeadAdsPost": "Facebook et Google Lead Ads POST into LeadIntakeService — same path as form submissions"
  },
  "labels": {
    "experimentName": "Experiment name",
    "slug": "Slug",
    "variantPageIdsComma": "Variant page IDs (comma)",
    "trafficWeights": "Traffic weights",
    "campaignName": "Campaign Name",
    "adPlatformChannel": "Ad Platform / Channel",
    "allocatedBudgetInr": "Allocated Budget (INR)",
    "actualCostInr": "Actual Cost (INR)",
    "revenueAttributedInr": "Revenue Attributed (INR)",
    "attributionModel": "Attribution Model",
    "eGQ2EnterpriseCloudPromo": "e.g. Q2 Saisirprise Cloud Promo",
    "eGLinkedinAds": "e.g. LinkedIn Ads",
    "bannerTextCookieConsent": "Banner Text (Cookie Consent)",
    "privacyStatementForms": "Privacy Statement (Forms)",
    "crmLeadId": "CRM lead ID",
    "emailForDomainEnrich": "Email (for domain enrich)",
    "formName": "Form Name",
    "description": "Description",
    "captureType": "Capture Type",
    "fieldLabel": "Field Label",
    "fieldType": "Field Type",
    "optionsCommaSeparated": "Options (Comma separated)",
    "eGInboundDemoRequest": "e.g. Inbound Demo Request",
    "optionalInternalDescription": "Optional internal description...",
    "eGOrganizationName": "e.g. Organization Name",
    "eGSmallMediumEnterprise": "e.g. Small, Medium, Saisirprise",
    "pageTitle": "Page Title",
    "urlSlug": "URL Slug",
    "customDomain": "Custom Domain",
    "aBVariant": "A/B Variant",
    "landingPageTemplate": "Landing Page Template",
    "eGFreeEnterpriseAuditTrial": "e.g. Free Saisirprise Audit Trial",
    "eGEnterpriseAudit": "e.g. saisirprise-audit",
    "eGPromoMycompanyCom": "e.g. promo.mycompany.com",
    "ruleName": "Rule Name",
    "priorityOrder": "Priority Order",
    "assignToEmployee": "Assign à employé",
    "teamQueueCodeOptional": "Team / Queue Code (Optional)",
    "crmTerritoryOptional": "CRM territory (optional)",
    "eGIndiaRegionRouting": "e.g. India Region Routing",
    "leaveBlankForRoundRobinQueue": "Congé blank pour round-robin queue",
    "eGInSalesTeam": "e.g. IN_SALES_TEAM",
    "none": "— None —",
    "scoreDeltaPoints": "Score Delta (Points)",
    "triggerEvent": "Trigger Event",
    "eGEnterpriseIndustryMatch": "e.g. Saisirprise Industry Match",
    "eG15Or10": "e.g. 15 ou -10",
    "code": "Code",
    "name": "Nom",
    "partnerXReferrals": "Partner X Referrals"
  },
  "formActions": {
    "saveRoutingPolicy": "Enregistrer la politique de routage",
    "saveCampaign": "Enregistrer la campagne",
    "addSource": "Ajouter une source",
    "saveScoringRule": "Enregistrer la règle de notation",
    "addField": "Ajouter un champ",
    "saveAndPublishForm": "Enregistrer et publier le formulaire"
  },
  "listActions": {
    "createExperiment": "Créer une expérience",
    "getEmbedCode": "Obtenir le code d'intégration",
    "publishLandingPage": "Publier la page d'atterrissage"
  }
}
